module.exports = __webpack_public_path__ + "assets/img/4989b95e91fdb081ad497aeaf099476d.svg";